import React from "react";
import { Row, Col, Card, CardBody, CardTitle, CardText } from "reactstrap";
import { Star, CreditCard, Briefcase, Hash } from "react-feather";
import { getFormattedNumber } from "utility/helpers";
import styled from "styled-components";

const UtilizationSection = styled(Row)`
  display: flex;
  align-items: center;
  margin-bottom: 3rem;
  margin-top: 1rem;
  padding: 0;

  .util-card-icon {
    background: #e0e7ff;
    border-radius: 50%;
    padding: 8px;
    margin-left: 16px;
    color: #0000ff;
  }
`;

const UtilCard = styled(Card)`
  border-radius: 12px !important;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  display: grid;
  grid-template-columns: 1fr 2fr;
`;

const CardIconContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

const StyledCardTitle = styled(CardTitle)`
  margin-bottom: 0.5rem;
`;

const StyledCardText = styled(CardText)`
  font-weight: bold;
`;

const UtilCardIconContainer = styled.div`
  background: #e0e7ff;
  border-radius: 50%;
  padding: 8px;
  color: #0000ff;
`;

const CardContainer = styled(Col)`
  margin-top: 0.5rem;
  margin-bottom: 0.5rem;
`;

const UtilizationStats = ({
  totalAllocation,
  totalLiquidation,
  unliquidatedBalance,
  noOfReports,
}) => {
  return (
    <UtilizationSection>
      <CardContainer lg="3">
        <UtilCard>
          <CardIconContainer>
            <UtilCardIconContainer>
              <CreditCard />
            </UtilCardIconContainer>
          </CardIconContainer>

          <CardBody>
            <StyledCardTitle tag="h6">{"Total Allocation"}</StyledCardTitle>
            <StyledCardText>
              {getFormattedNumber(totalAllocation)}
            </StyledCardText>
          </CardBody>
        </UtilCard>
      </CardContainer>
      <CardContainer lg="3">
        <UtilCard>
          <CardIconContainer>
            <UtilCardIconContainer>
              <Star />
            </UtilCardIconContainer>
          </CardIconContainer>

          <CardBody>
            <StyledCardTitle tag="h6">{"Total Liquidation"}</StyledCardTitle>
            <StyledCardText>
              {getFormattedNumber(totalLiquidation)}
            </StyledCardText>
          </CardBody>
        </UtilCard>
      </CardContainer>
      <CardContainer lg="3">
        <UtilCard>
          <CardIconContainer>
            <UtilCardIconContainer>
              <Briefcase />
            </UtilCardIconContainer>
          </CardIconContainer>
          <Col>
            <CardBody>
              <StyledCardTitle tag="h6">
                {"Unliquidated Balance"}
              </StyledCardTitle>
              <StyledCardText>
                {getFormattedNumber(unliquidatedBalance)}
              </StyledCardText>
            </CardBody>
          </Col>
        </UtilCard>
      </CardContainer>
      <CardContainer lg="3">
        <UtilCard>
          <CardIconContainer>
            <UtilCardIconContainer>
              <Hash />
            </UtilCardIconContainer>
          </CardIconContainer>

          <CardBody>
            <StyledCardTitle tag="h6">{"No. of Reports"}</StyledCardTitle>
            <StyledCardText>{noOfReports}</StyledCardText>
          </CardBody>
        </UtilCard>
      </CardContainer>
    </UtilizationSection>
  );
};

export default UtilizationStats;
